import { isEqual } from 'lodash'
import { useCallback, useRef, useState } from 'react'
import { useSocket } from './useSocket'

export const useSocketData = <T extends object>(url: string) => {
    const [data, setData] = useState<T>()
    const previousData = useRef<T>(undefined)

    const handleMessage = useCallback((data: T) => {
        if (!isEqual(previousData.current, data)) {
            previousData.current = data

            setData(data)
        }
    }, [])

    const { isConnected, sendMessage, connect, disconnect } = useSocket<T>(url, handleMessage)

    return {
        isConnected,
        data,
        sendMessage,
        connect,
        disconnect,
    }
}
